import React, {PropTypes} from 'react';
import d3 from 'd3';
import './style.scss';

// const percentColors = [
//     { pct: 0.0, color: { r: 0x00, g: 0xff, b: 0 } },
//     { pct: 0.5, color: { r: 0xff, g: 0xff, b: 0 } },
//     { pct: 1.0, color: { r: 0xff, g: 0x00, b: 0 } }
// ];

const percentColors = [
    { pct: 0.0, color: { r: 0x43, g: 0xcc, b: 0x83 } },
    { pct: 0.5, color: { r: 0xf8, g: 0xfa, b: 71 } },
    { pct: 1.0, color: { r: 0xef, g: 0x53, b: 50 } }
];

const getColorForPercentage = function(pct) {
    let i;
    for (i = 1; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
};

//http://codepen.io/boars/pen/kzFvj
class Gauge extends React.Component {

    static propTypes = {
        percent: PropTypes.number,
        numSections: PropTypes.number
    };

    static defaultProps = {
        numSections: 5
    };

    componentDidMount() {
        this.draw();
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.percent !== this.props.percent || nextProps.numSections !== this.props.numSections;
    }

    componentDidUpdate() {
        d3.select(this.refs.gauge).html('');
        this.draw();
    }

    draw = () => {
        let Needle, arc, arcEndRad, arcStartRad, barWidth, chart, chartInset, degToRad,
            el, endPadRad, height, margin, needle, padRad, percToDeg, percToRad,
            radius, sectionIndx, sectionPerc, startPadRad, svg, totalPercent, width, _i;

        const {percent, numSections} = this.props;
        barWidth = 20;
        sectionPerc = 1 / numSections / 2;
        padRad = 0.05;
        chartInset = 0;
        totalPercent = .75;

        el = d3.select(/*'#chartguage'*/this.refs.gauge);

        margin = {
            top: 120,
            right: 0,
            bottom: 0,
            left: 0
        };


        width = 300;
        height = 150;
        //width = el[0][0].offsetWidth + margin.left;
        //height = el[0][0].offsetWidth + margin.top;
        //radius = Math.min(width, height) / 2;
        radius = 100;

        percToDeg = function (perc) {
            return perc * 360;
        };

        percToRad = function (perc) {
            return degToRad(percToDeg(perc));
        };

        degToRad = function (deg) {
            return deg * Math.PI / 180;
        };

        svg = el.append('svg').attr('width', width + margin.left + margin.right).attr('height', height);

        chart = svg.append('g').attr('transform', "translate(" + ((width / 2) + margin.left) + ", " + margin.top + ")");

        for (sectionIndx = _i = 1; 1 <= numSections ? _i <= numSections : _i >= numSections; sectionIndx = 1 <= numSections ? ++_i : --_i) {
            arcStartRad = percToRad(totalPercent);
            arcEndRad = arcStartRad + percToRad(sectionPerc);
            totalPercent += sectionPerc;
            startPadRad = sectionIndx === 0 ? 0 : padRad / 2;
            endPadRad = sectionIndx === numSections ? 0 : padRad / 2;
            arc = d3.svg.arc().outerRadius(radius - chartInset).innerRadius(radius - chartInset - barWidth).startAngle(arcStartRad + startPadRad).endAngle(arcEndRad - endPadRad);
            chart.append('path').attr('class', "arc chart-color" + sectionIndx).attr('d', arc).attr('fill',getColorForPercentage((sectionIndx - 1)/(numSections - 1)));
        }

        Needle = (function () {
            function Needle(len, radius) {
                this.len = len;
                this.radius = radius;
            }

            Needle.prototype.drawOn = function (el, perc) {
                el.append('circle').attr('class', 'needle-center').attr('cx', 0).attr('cy', 0).attr('r', this.radius);
                return el.append('path').attr('class', 'needle').attr('d', this.mkCmd(perc));
            };

            Needle.prototype.animateOn = function (el, perc) {
                let self;
                self = this;
                return el.transition().delay(500).ease('bounce').duration(2000).selectAll('.needle').tween('progress', function () {
                    return function (percentOfPercent) {
                        let progress;
                        progress = percentOfPercent * perc;
                        return d3.select(this).attr('d', self.mkCmd(progress));
                    };
                });
            };

            Needle.prototype.mkCmd = function (perc) {
                let centerX, centerY, leftX, leftY, rightX, rightY, thetaRad, topX, topY;
                thetaRad = percToRad(perc / 2);
                centerX = 0;
                centerY = 0;
                topX = centerX - this.len * Math.cos(thetaRad);
                topY = centerY - this.len * Math.sin(thetaRad);
                leftX = centerX - this.radius * Math.cos(thetaRad - Math.PI / 2);
                leftY = centerY - this.radius * Math.sin(thetaRad - Math.PI / 2);
                rightX = centerX - this.radius * Math.cos(thetaRad + Math.PI / 2);
                rightY = centerY - this.radius * Math.sin(thetaRad + Math.PI / 2);
                return "M " + leftX + " " + leftY + " L " + topX + " " + topY + " L " + rightX + " " + rightY;
            };

            return Needle;

        })();

        needle = new Needle(90, 8);

        needle.drawOn(chart, 0);

        needle.animateOn(chart, percent);
    };

    render() {
        return <div id="chartguage" ref="gauge"></div>;
    }
}

export default Gauge;